// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__wu3Y2","contact__inner":"contact_contact__inner__4nfro","contact__inner-btns":"contact_contact__inner-btns__YX79O"};